(function (jQuery, undefined) {

    var smapi = window.smapi = window.smapi || {},
        extend = jQuery.extend,
        each = jQuery.each,
        proxy = jQuery.proxy,
        noop = jQuery.noop,
        isFunction = jQuery.isFunction,
        globalize = window.Globalize;

    if (typeof smapi.constant === "undefined") {
        extend(smapi, { constant: {} });
    }

    // Debug Constants
    var applicationDebugFlag = false;
    var accountDebugFlag = false;
    var profileDebugFlag = false;

    // Validation Constants
    var validate_FieldRequired_Key = 'Validate_FieldRequired';
    var validate_ErrorInFormat0_Key = 'Validate_ErrorInFormat0';
    var validate_GreaterThan0_Key = 'Validate_GreaterThan0';
    var validate_GreaterOrEqualThan0_Key = 'Validate_GreaterOrEqualThan0';
    var validate_LessThan0_Key = 'Validate_LessThan0';
    var validate_LessOrEqualThan0_Key = 'Validate_LessOrEqualThan0';
    var validate_IncorrectFormat_Key = 'Validate_IncorrectFormat';
    var validate_0CharactersOrLess_Key = 'Validate_0CharactersOrLess';
    var validate_0CharactersOrLess_Key_flexi = 'Validate_0CharactersOrLessFlexi';
    var validate_GreaterOrEqualThan0_Key_flexi = 'Validate_GreaterThanEqual0Flexi';
    var validate_LessOrEqualThan0_Key_flexi = 'Validate_LessThanEqual0Flexi';
    var validate_Number_Range_flexi = 'Validate_Number_Range_Flexi';
    var validate_MustBeNumeric_Flexi = 'Validate_MustBeNumeric_Flexi';
    var validate_MustBeInteger_Flexi = 'Validate_MustBeInteger_Flexi';
    var validate_MustBeADate_Flexi = 'Validate_MustBeADate_Flexi';
    var validate_MustBeADate_Key = 'Validate_MustBeADate';
    var validate_EffectiveBeginDate_Key = 'IncorrectEffectiveBeginDate';
    var validate_EffectiveEndDate_Key = 'IncorrectEffectiveEndDate';
    var validate_MustBeNumeric_Key = 'Validate_MustBeNumeric';
    var validate_GpaMustBeLessOrEqual_Key = 'Validate_GpaMustBeLessOrEqual';
    var validate_GpaMustBeBiggerOrEqual_Key = 'Validate_GpaMustBeBiggerOrEqual';
    var validate_GpaScaleMustBeLessOrEqual_Key = 'Validate_GpaScaleMustBeLessOrEqual';
    var validate_GpaScaleMustBeBiggerOrEqual_Key = 'Validate_GpaScaleMustBeBiggerOrEqual';
    var validate_DuplicateEmail_Key = 'Validate_DuplicateEmail';
    var validate_Decimals = 'Validate_Decimals';
    var validate_ItsNotAValidPhoneNumber = 'Validate_ItsNotAValidPhoneNumber';
    var Validate_MustBeProperDateOfBirth_Key = 'Validate_MustBeProperDateOfBirth';
    var validate_ErrorInCityValue_Key = 'validate_ErrorInCityValue';
    var validate_SponsorPageDescription_Key = 'SponsorPageMessage';
    var validate_SponsorDocumentUploadDescription_Key = 'UploadLetterMessage';
    var validate_EmptyAmountinMultiPaymentSelection = 'EmptyAmountinMultiPaymentSelection';
    var validate_HigherAmountinMultiPaymentSelection = 'HigherAmountinMultiPaymentSelection';
    var validate_LowerAmountinMultiPaymentSelection = 'LowerAmountinMultiPaymentSelection';
    var client = {
        RCA : '2964',
        MMU : '5328',
        DBS : '3318'
    };    
    var validate_MustBeProperQualificationObtainedDate = 'MustBeProperQualificationObtainedDate';
    var validate_DuplicateProvincialBMNEntry_Key = "DuplicateProvincialBMNEntry";

    jQuery.extend(true, smapi.constant, {
        applicationDebugFlag: applicationDebugFlag,
        accountDebugFlag: accountDebugFlag,
        profileDebugFlag: profileDebugFlag, 
        validate_FieldRequired_Key: validate_FieldRequired_Key,
        validate_ErrorInFormat0_Key: validate_ErrorInFormat0_Key,
        validate_GreaterThan0_Key: validate_GreaterThan0_Key,
        validate_0CharactersOrLess_Key_flexi: validate_0CharactersOrLess_Key_flexi,
        validate_GreaterOrEqualThan0_Key_flexi: validate_GreaterOrEqualThan0_Key_flexi,
        validate_LessOrEqualThan0_Key_flexi: validate_LessOrEqualThan0_Key_flexi,
        validate_Number_Range_flexi: validate_Number_Range_flexi,
        validate_MustBeNumeric_Flexi: validate_MustBeNumeric_Flexi,
        validate_MustBeInteger_Flexi: validate_MustBeInteger_Flexi,
        validate_MustBeADate_Flexi: validate_MustBeADate_Flexi,
        validate_GreaterOrEqualThan0_Key: validate_GreaterOrEqualThan0_Key,
        validate_LessThan0_Key: validate_LessThan0_Key,
        validate_LessOrEqualThan0_Key: validate_LessOrEqualThan0_Key,
        validate_IncorrectFormat_Key: validate_IncorrectFormat_Key,
        validate_0CharactersOrLess_Key: validate_0CharactersOrLess_Key,
        validate_MustBeADate_Key: validate_MustBeADate_Key,
        validate_EffectiveBeginDate_Key: validate_EffectiveBeginDate_Key,
        validate_EffectiveEndDate_Key: validate_EffectiveEndDate_Key,
        validate_MustBeNumeric_Key: validate_MustBeNumeric_Key,
        validate_GpaMustBeLessOrEqual_Key: validate_GpaMustBeLessOrEqual_Key,
        validate_GpaMustBeBiggerOrEqual_Key: validate_GpaMustBeBiggerOrEqual_Key,
        validate_GpaScaleMustBeLessOrEqual_Key: validate_GpaScaleMustBeLessOrEqual_Key,
        validate_GpaScaleMustBeBiggerOrEqual_Key: validate_GpaScaleMustBeBiggerOrEqual_Key,
        validate_DuplicateEmail_Key: validate_DuplicateEmail_Key,
        validate_Decimals: validate_Decimals,
        validate_ItsNotAValidPhoneNumber: validate_ItsNotAValidPhoneNumber,
        Validate_MustBeProperDateOfBirth_Key: Validate_MustBeProperDateOfBirth_Key,
        validate_ErrorInCityValue_Key: validate_ErrorInCityValue_Key,
        validate_SponsorPageDescription_Key:validate_SponsorPageDescription_Key,
        validate_SponsorDocumentUploadDescription_Key:validate_SponsorDocumentUploadDescription_Key,
        validate_EmptyAmountinMultiPaymentSelection:validate_EmptyAmountinMultiPaymentSelection,
        validate_HigherAmountinMultiPaymentSelection:validate_HigherAmountinMultiPaymentSelection,
        validate_LowerAmountinMultiPaymentSelection:validate_LowerAmountinMultiPaymentSelection,
        client: client,
        validate_MustBeProperQualificationObtainedDate: validate_MustBeProperQualificationObtainedDate,
        validate_DuplicateProvincialBMNEntry_Key: validate_DuplicateProvincialBMNEntry_Key
    });

})(jQuery);
